import { DeliveryMode } from '../../../../../../services/exports/Constants';

export default {
  types: {
    circle: 'Cercle',
    polygon: 'Polygone',
    zip: 'Code postal',
  },
  fields: {
    name: {
      label: 'Nom',
    },
    color: {
      label: 'Couleur',
    },
    min_threshold: {
      label: 'Montant minimum de commande',
    },
    max_threshold: {
      label: 'Montant maximum de commande',
    },
    fee: {
      [DeliveryMode.Internal]: {
        label: 'Frais de livraison',
      },
      [DeliveryMode.External]: {
        label: 'Frais pris en charge par le restaurant',
      },
    },
    zip_codes: {
      label: 'Codes postaux (un par ligne)',
    },
  },
  labels: {
    hidden: '(masqué)',
  },
  buttons: {
    save: 'Enregistrer',
    cancel_changes: 'Annuler les modifications',
    add_max_order_amount: 'Ajouter un montant max de commande',
  },
  modals: {
    delete_confirmation: {
      title: 'Êtes-vous sûr de vouloir supprimer {{name}}',
    },
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement des modifications pour {{name}}",
    delivery_zone_got_updated: 'Modifications enregistrées avec succès pour {{name}}',
    failed_to_delete_delivery_zone: 'Échec de la suppression de {{name}}',
    delivery_zone_got_deleted: '{{name}} supprimé avec succès',
  },
};
